import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppBaseService } from "../../services/http.service";
import { MICROSERVICES } from "../../constants/web-services";
import { ReplaySubject, takeUntil } from "rxjs";
import { UserLoginModel, UserUnitList } from "../signin/signin.model";
import { CookieService } from "ngx-cookie-service";
import { IdleTimeoutService } from "../../services/idle-timeout.service";
//import { PushNotificationComponent } from "../../modules/push-notification/controllers/push-notification/push-notification.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import localForage from "localforage";

@Component({
  selector: "app-auth-callback",
  templateUrl: "./auth-callback.component.html",
  styleUrl: "./auth-callback.component.scss",
})
export class AuthCallbackComponent implements OnInit {
  process: boolean = false;
  private unsubscribe: ReplaySubject<boolean> = new ReplaySubject(1);
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private baseservice: AppBaseService,
    private cookieService: CookieService,
    private idleService: IdleTimeoutService,
   // private pushNotification: PushNotificationComponent,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    const userName = this.route.snapshot.queryParamMap.get("data");
    if (userName) {
      try {
        this.process = true;
         let loginData = {
                  userName: userName,
                  login:"AD"
                };
        this.baseservice.setResourceURL(MICROSERVICES.IDENTITY_SERVICE);
        this.baseservice
          .loginResource("user/login",loginData)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe({
            next: (res: any) => {
              let data: UserLoginModel = res.body;
              if (data) {
                // if (data && !data.isResetRequired) {
                this.cookieService.set("isClinical", "true", 1, "/");
                localStorage.setItem(
                  "cashCounterDetailsList",
                  JSON.stringify(data.cashCounterDetailsList)
                );
                localStorage.setItem("userId", btoa(data.userId));
                localStorage.setItem("userName", btoa(data.userName));
                localStorage.setItem("userEmail", btoa(data.userEmailId));
                localStorage.setItem(
                  "employeeId",
                  data.employeeDetails ? data.employeeDetails.employeeId : ""
                );
                localStorage.setItem("sessionTimeOut", data.sessionTimeOut);
                localStorage.setItem(
                  "authorization",
                  res.headers.get("Authorization")
                );
                let tokenValue = res.headers.get("Authorization");
                let unit: UserUnitList = data.userUnitList.find(
                  (i) => i.isDefault == true
                );
                localStorage.setItem(
                  "refreshtoken",
                  res.headers.get("refresh-token")
                );
                let refershValue = res.headers.get("refresh-token");
                this.idleService.startWatching();
                if (unit) {
                  localStorage.setItem("unitId", btoa(unit.unitId));
                  localStorage.setItem("unitCode", btoa(unit.unitCode));
                  localStorage.setItem("orgCode", btoa(unit.orgCode));
                  localStorage.setItem("orgId", btoa(unit.orgId));
                  localStorage.setItem(
                    "userRole",
                    JSON.stringify(unit.userRole)
                  );
                  localStorage.setItem(
                    "userRightSpecialList",
                    JSON.stringify(unit.userSpecialRightsList)
                  );
                  localStorage.setItem(
                    "userStoreList",
                    JSON.stringify(unit.userStoreList)
                  );
                  localStorage.setItem(
                    "userDetailWithCashCounters",
                    JSON.stringify(unit.userDetailWithCashCounters)
                  );
                  this.getRoleInfo(data, unit, tokenValue);
                  localStorage.setItem("unitPrefix", unit.unitPrefix);

                  this.process = false;
                  const roleId = unit.userRole.roleId;
                  //this.pushNotification.connect(roleId);
                } else {
                  this.snackBar.open(
                    "Validation",
                    "User does not have any default Unit",
                    {
                      duration: 3000,
                    }
                  );
                }
              }
              //  else if(data && data.isResetRequired) {
              //   this.openPasswordResetDialog();
              // }
            },
            error: (err) => {
              this.process = false;
            },
          });
      } catch (ex) {
        this.process = false;
      }
    }
  }
  getRoleInfo(data, unit, tokenData) {
    data["userUnitList"] = data.userUnitList;
    data["roleNotificationMappers"] = null;
    data["userUnitRole"] = null;
    data["userUnit"] = null;
    data["authorization"] = tokenData ? tokenData : "";
    data["orgCode"] = unit.orgCode;
    data["orgDesc"] = unit.orgDescription;
    localForage.setItem("unit", unit);
    localForage.setItem("role", {
      id: unit.userRole ? unit.userRole.roleId : "",
      roleName: unit.userRole ? unit.userRole.roleDescription : "",
      roleCode: unit.userRole ? unit.userRole.roleCode : "",
    });
    if (unit.userRole) {
      localStorage.setItem("roleName", btoa(unit.userRole.roleDescription));
    }
    sessionStorage.setItem("isStoreDialogOpened", "false");

    // this.langService.getLanguageList();
    localForage.setItem("auth-data", data, (err) => {
      localStorage.setItem("lan", "en");
      localStorage.setItem("passcode", "true");
      localStorage.setItem("isLoggedin", "true");
      this.router.navigate(["Dashboard/dash"]);
    });
  }
}
